//import { ru } from "vuetify/locale";
import en from "./en.js";
import ru from "./ru.js";
import ro from "./ro.js";

let lang = localStorage.getItem("language")
  ? localStorage.getItem("language")
  : "ro";

export const locale = {
  locale: lang,
  fallback: "ro",
  globalInjection: true,
  messages: { en, ru, ro },
};
